import React from 'react';

class Header extends React.PureComponent {

	render() {
		return (
			<header className={`header ${this.props.className ? this.props.className : ''}`}>
				<div className="header__container">
					<h1 className="header__heading">{ this.props.title }</h1>
					<div className="header__aside">
						{ this.props.children }
					</div>
				</div>
			</header>
		)
	}
}

export default Header;
